import { render, staticRenderFns } from "./customised_theme_design.vue?vue&type=template&id=1f3b0d9a&scoped=true"
import script from "./customised_theme_design.vue?vue&type=script&lang=js"
export * from "./customised_theme_design.vue?vue&type=script&lang=js"
import style0 from "./customised_theme_design.vue?vue&type=style&index=0&id=1f3b0d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3b0d9a",
  null
  
)

export default component.exports